import { useQuery } from '@tanstack/react-query';
import { useApi } from './client.js';
import type { DatasetSummary, CqsExecutionResult } from './types.js';
import type { CqsQuery } from '@canopy/query-spec';

export function useDatasets() {
  const api = useApi();
  return useQuery<DatasetSummary[]>({
    queryKey: ['datasets'],
    queryFn: () => api.fetch('/datasets'),
  });
}

export function useCqsPreview(query: CqsQuery | null) {
  const api = useApi();
  return useQuery<CqsExecutionResult>({
    queryKey: ['cqs-preview', query ? JSON.stringify(query) : null],
    queryFn: () =>
      api.fetch('/query', {
        method: 'POST',
        body: JSON.stringify(query),
      }),
    enabled: !!query,
    staleTime: 10_000,
  });
}
